import type { GeneratedDimension } from "@keydials/api-client";

/** What an item's date is called when a check doesn't name it. */
export const DEFAULT_ITEM_DATE_LABEL = "Review date";

/**
 * What the apps call an item's date on one check (KEY-809): the check's own name for it — "Target date" on a
 * to-do scale — or "Review date". Wording only; the date ladder reads the same date whatever it is called.
 */
export function itemDateLabel(dimension: Pick<GeneratedDimension, "dateLabel"> | null | undefined): string {
  const own = dimension?.dateLabel?.trim();
  return own ? own : DEFAULT_ITEM_DATE_LABEL;
}

/** The badge on a dated item with no revert target: "Review due 3 Oct", or "Target date 3 Oct" when renamed. */
export function itemDateBadge(dateLabel: string, formattedDate: string): string {
  return dateLabel === DEFAULT_ITEM_DATE_LABEL ? `Review due ${formattedDate}` : `${dateLabel} ${formattedDate}`;
}
